const cards = [
  {
    tag: '独家',
    title: '头部MCN机构内部员工大爆料：刷量手段全揭秘',
    summary: '前员工匿名披露公司内部使用的多套数据造假工具与操作流程',
    image: 'https://readdy.ai/api/search-image?query=Dark%20office%20with%20multiple%20computer%20screens%20showing%20fake%20data%2C%20anonymous%20source%20aesthetic%2C%20coral%20orange%20warning%20accents%2C%20investigative%20journalism%20theme%2C%20moody%20cinematic%20lighting%2C%20high%20contrast%2C%20professional%20expose%20photography&width=800&height=450&seq=cards-01&orientation=landscape',
  },
  {
    tag: '追踪',
    title: '知名综艺节目录制过程中意外事件全记录',
    summary: '现场工作人员匿名提供事件始末时间线与多方当事人说法',
    image: 'https://readdy.ai/api/search-image?query=Television%20studio%20set%20in%20darkness%20with%20dramatic%20spotlight%2C%20behind%20the%20scenes%20chaos%20theme%2C%20coral%20orange%20accent%20glow%2C%20entertainment%20industry%20expose%2C%20cinematic%20noir%20lighting%2C%20high%20contrast%2C%20suspenseful%20atmosphere&width=800&height=450&seq=cards-02&orientation=landscape',
  },
  {
    tag: '猛料',
    title: '电商平台商家自曝刷单产业链完整操作手册',
    summary: '多位商家联合爆料，揭示平台内部漏洞如何被系统性利用',
    image: 'https://readdy.ai/api/search-image?query=Dark%20warehouse%20filled%20with%20cardboard%20boxes%2C%20ecommerce%20fraud%20investigation%20theme%2C%20coral%20orange%20accent%20light%2C%20mysterious%20industrial%20setting%2C%20cinematic%20noir%2C%20high%20contrast%2C%20investigative%20documentary%20style&width=800&height=450&seq=cards-03&orientation=landscape',
  },
  {
    tag: '热榜',
    title: '某知名艺人团队内部聊天记录意外泄漏始末',
    summary: '涉及多位艺人私下对行业现状的真实评价与不满情绪',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20displaying%20leaked%20chat%20messages%20in%20dark%20environment%2C%20privacy%20breach%20theme%2C%20coral%20orange%20notification%20glow%2C%20mysterious%20digital%20leaks%20aesthetic%2C%20cinematic%20lighting%2C%20high%20contrast%2C%20suspenseful%20mood&width=800&height=450&seq=cards-04&orientation=landscape',
  },
  {
    tag: '独家',
    title: '娱乐圈选角内幕：角色分配背后的利益输送网络',
    summary: '多位业内人士匿名揭示影视项目选角过程中的潜规则与暗箱操作',
    image: 'https://readdy.ai/api/search-image?query=Casting%20audition%20room%20with%20empty%20chairs%20under%20dramatic%20lighting%2C%20entertainment%20industry%20corruption%20theme%2C%20coral%20orange%20spotlight%2C%20mysterious%20behind%20the%20scenes%20aesthetic%2C%20cinematic%20noir%2C%20high%20contrast%2C%20editorial%20photography&width=800&height=450&seq=cards-05&orientation=landscape',
  },
  {
    tag: '追踪',
    title: '网红带货翻车事件背后的供应链黑幕调查',
    summary: '深入调查发现多个知名带货主播合作的工厂存在严重品控问题',
    image: 'https://readdy.ai/api/search-image?query=Dark%20factory%20interior%20with%20assembly%20line%20and%20defective%20products%2C%20supply%20chain%20investigation%20theme%2C%20coral%20orange%20warning%20sign%20glow%2C%20consumer%20safety%20expose%2C%20cinematic%20noir%20lighting%2C%20high%20contrast%2C%20investigative%20journalism&width=800&height=450&seq=cards-06&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950">独家猛料</h2>
          <p className="text-foreground-500 text-sm mt-1">编辑团队精选 · 不容错过的重磅内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cards.map((item, i) => (
            <a
              key={i}
              href="#cards"
              className="group block rounded-2xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-accent-300/40 transition-all duration-300"
            >
              <div className="aspect-[16/9] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-2">
                  {item.tag}
                </span>
                <h3 className="text-foreground-900 font-bold text-sm md:text-base leading-snug mb-1.5">{item.title}</h3>
                <p className="text-foreground-500 text-xs md:text-sm leading-relaxed">{item.summary}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}